import React from 'react';
import Cookies from 'js-cookie';
import '../Catalog/Catalog.css';
import './FavouriteContainer.css';
import FavouriteButton from '../FavouriteButton/FavouriteButton';
import Footer from '../Footer/Footer';

const formatCurrency = (value) => `${Number(value || 0).toLocaleString('ru-RU')} ₽`;

const FavouriteContainer = ({ data }) => {
    const selectedSect = window.categories?.[Cookies.get('selectedSection')] || 'women';
    const products = data?.Products?.$values || [];

    return (
        <>
            <section className="favourite-page">
                <div className="catalog-shell">
                    <div className="catalog-hero favourite-hero">
                        <div className="catalog-hero__eyebrow">Wishlist</div>
                        <div className="catalog-hero__content">
                            <div>
                                <h1 className="catalog-hero__title">Избранное</h1>
                                <p className="catalog-hero__description">
                                    Сохранённые позиции, к которым хочется вернуться позже.
                                </p>
                            </div>
                            <div className="catalog-hero__meta">
                                <span>{products.length} styles</span>
                                <span>Saved for later</span>
                            </div>
                        </div>
                    </div>

                    {products.length === 0 ? (
                        <div className="favourite-empty">
                            <p>Сохранённых товаров пока нет.</p>
                            <a href={`/shopping/${selectedSect}/items`}>Перейти в каталог</a>
                        </div>
                    ) : <ul className="catalog-grid favourite-grid">
                        {products.map((item) => {
                            const isOutOfStock = !item.IsAvailable;
                            const productUrl = !isOutOfStock ? `/shopping/${selectedSect}/${item.Sename}` : undefined;
                            const imageUrl = item.ImagesPath?.$values?.[0]?.URL;
                            const sizes = item.SizeStr ? [item.SizeStr] : [];
                            const sizeLabel = sizes.length > 3 ? 'Несколько размеров' : sizes.join(', ');

                            return (
                                <li key={item.$id || item.ProductId} className="catalog-card">
                                    <div className="catalog-card__favorite">
                                        <FavouriteButton productId={item.ProductId} />
                                    </div>

                                    <a href={productUrl} className="catalog-card__link" aria-disabled={isOutOfStock}>
                                        <div className="catalog-card__image-frame">
                                            <div className="catalog-card__image-wrap">
                                                <img
                                                    src={imageUrl}
                                                    alt={item.Title}
                                                    className={`catalog-card__image ${isOutOfStock ? 'is-muted' : ''}`}
                                                    height="480"
                                                    width="360"
                                                />
                                                {isOutOfStock && <span className="catalog-card__badge">Распродано</span>}
                                            </div>
                                        </div>

                                        <div className="catalog-card__body">
                                            <div className="catalog-card__brand">{item.BrandName}</div>
                                            <div className="catalog-card__title">{item.Title}</div>
                                            <div className="catalog-card__details">{sizeLabel || 'Размер уточняется'}</div>
                                            <div className="catalog-card__price">{formatCurrency(item.Price)}</div>
                                        </div>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>}
                </div>
            </section>

            <Footer />
        </>
    );
};

export default FavouriteContainer;
